import { computed, reactive } from "vue";
import { authState } from "./auth";
import { roomState } from "./room";
import { ws_instance } from "../websocket/ws-instance";
import { fetcher } from "../api/fetcher";
import { clearStateAndUnsubscribe, subscribeWaitRoomEvents } from "./waitRoomState";

const admins = reactive<string[]>([]);
let initialized = false;

export function isAdmin(who: string) {
  return admins.includes(who);
}

export const isSelfAdmin = computed(() => {
  return admins.includes(authState.id);
});

export async function adminDataSetup(rid = "") {
  if (initialized) return;
  initialized = true;
  const roomId = rid || roomState.id;
  if (!roomId) throw "rid empty";
  ws_instance.addEventListener("admin-assign", (data: string) => {
    setAdmin(data,rid);
  });
  ws_instance.addEventListener("admin-revoke", (data: string) => {
    removeAdmin(data);
  });
  const res = (await fetcher.get({
    path: `/room-admins/${roomId}`,
  })) as { data: string[] };
  res.data.forEach((a) => {
    setAdmin(a);
  });
}

function setAdmin(a: string, rid?: string) {
  if (!admins.includes(a)) {
    admins.push(a);
    if (a === authState.id) {
      subscribeWaitRoomEvents(rid);
    }
  }
}

function removeAdmin(data: string) {
  const adminIdx = admins.findIndex((a) => a === data);
  if (adminIdx > -1) {
    admins.splice(adminIdx, 1);
    if (data === authState.id) {
      clearStateAndUnsubscribe();
    }
  }
}

export async function assignAdminRequest(userId: string) {
  await fetcher.post({
    path: "/room-admins",
    payload: {
      userId
    }
  })
}

export async function revokeAdminRequest(userId: string) {
  await fetcher.delete({
    path: "/room-admins",
    payload: {
      userId
    }
  })
}
